import { render, staticRenderFns } from "./AltaPerfil.vue?vue&type=template&id=755c3b17&scoped=true&"
import script from "./AltaPerfil.vue?vue&type=script&lang=js&"
export * from "./AltaPerfil.vue?vue&type=script&lang=js&"
import style0 from "./AltaPerfil.vue?vue&type=style&index=0&id=755c3b17&scoped=true&lang=css&"
import style1 from "./AltaPerfil.vue?vue&type=style&index=1&id=755c3b17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755c3b17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VChip,VProgressCircular,VSelect})
